module.exports = __webpack_public_path__ + "static/media/headshot.703cf1a8.jpg";